import React from 'react';
import {isIOS, isMacOs} from 'react-device-detect';
import {StyleProp, View, ViewStyle} from 'react-native';
import {Platform} from 'react-native';
import {makeStyles} from '@rneui/themed';

import useStorePriceDisplayConditions from '../../hooks/usePriceDisplayConditions';
import {ExtraPrice} from '../../transport/apiServiceResponse';
import {ProductDisplayRules} from '../../utils/rewards';
import Text from '../themed/Text';

type Props = {
  containerStyle?: StyleProp<ViewStyle>;
  externalSellType?: ExtraPrice['external_sell_type'];
  productDisplayRules: ProductDisplayRules;
  center?: boolean;
};

function MembersPriceLabel({containerStyle, externalSellType, productDisplayRules, center}: Props) {

  const styles = useStyles({center});
  const {showMemberPrice} = useStorePriceDisplayConditions();
  
  const MEMBER_TEXT = {
    public: 'MEMBERS PRICE',
    private: 'JUST FOR YOU',
  };
  
  const STYLES = {
    public: styles.containerPublic,
    private: styles.containerPrivate,
  };

  if (!externalSellType
    || (externalSellType === 'private' && !(showMemberPrice.privatePricing && productDisplayRules.presentAsPrivateMemberProduct))
    || (externalSellType === 'public' && !(showMemberPrice.publicPricing && productDisplayRules.presentAsPublicMemberProduct))) {
      // If we return null, there will be vertical spacing issues
      return <View style={[styles.containerCommon, styles.noBackground]} />
  }

  return (
    <View
      style={[
        styles.containerCommon,
        containerStyle,
        STYLES[externalSellType],
      ]}>
      <Text style={styles.text}>{MEMBER_TEXT[externalSellType]}</Text>
    </View>
  );
}

export default MembersPriceLabel;

const useStyles = makeStyles((theme, props: Pick<Props, 'center'>) => ({
  containerCommon: {
    height: 22,
    paddingHorizontal: 4,
    justifyContent: 'center',
  },
  containerPublic: {
    backgroundColor: theme.colors.yellow,
  },
  containerPrivate: {
    borderWidth: 2,
    borderColor: theme.colors.yellow,
  },
  noBackground: {backgroundColor: 'initial'},
  text: {
    color: theme.colors?.legacy?.text?.heading?.primary,
    fontSize: 14,
    fontWeight: 'bold',
    ...Platform.select({
      ios: {
        transform: [{translateY: 1}],
      },
      web:
        isMacOs || isIOS
          ? {
              transform: [{translateY: 1}],
            }
          : {
              transform: [{translateY: -1}],
            },
    }),
    ...(props.center ? {textAlign: 'center'} : {}),
  },
}));
